<template>
  <div v-resize="setContentHeight">
    <v-toolbar dark color="primary" class="pr-1">
      <v-btn icon @click="customGoBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Booking Details</v-toolbar-title>
    </v-toolbar>

    <div v-if="visitBooking" ref="bookingDetailsScrollable" class="scrollable">
      <v-card
        flat
        style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px"
      >
        <v-img
          :src="`${branchImagePath}${visitBooking.branchImageUrls[0]}`"
          max-height="154"
        ></v-img>

        <div class="pa-4 text-small">
          <div
            class="font-weight-bold mb-1 text-title-black"
            style="font-sizex: initial"
          >
            Library Visit
          </div>

          <v-row dense>
            <v-col class="col-1">
              <v-icon class="icon-small">mdi-account-multiple</v-icon>
            </v-col>
            <v-col>{{ visitBooking.pax }}</v-col>
          </v-row>

          <div>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-library</v-icon>
              </v-col>
              <v-col>{{ visitBooking.branchName }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-calendar-month</v-icon>
              </v-col>
              <v-col>{{ formatDate(visitBooking.startTime) }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-smaller">mdi-clock-outline</v-icon>
              </v-col>
              <v-col>{{
                formatPeriod(visitBooking.startTime, visitBooking.endTime)
              }}</v-col>
            </v-row>
            <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-counter</v-icon>
              </v-col>
              <v-col>{{
                formatAvailability(
                  visitBooking.availableVisitCapacity,
                  visitBooking.visitCapacityOfTheTimeSlot
                )
              }}</v-col>
            </v-row>

            <!-- <v-row dense>
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-information</v-icon>
              </v-col>
              <v-col>
                Your seat number will be assigned after a booking is made
                successfully.
              </v-col>
            </v-row> -->
          </div>

          <div class="button-group mt-4">
            <v-row>
              <v-col>
                <v-btn
                  v-if="authenticated"
                  key="1"
                  @click="book(visitBooking)"
                  dark
                  large
                  color="orange"
                  class
                  block
                >
                  <v-icon left dark>mdi-calendar-check</v-icon>Book
                </v-btn>

                <v-btn
                  v-else
                  key="2"
                  @click="loginAuth"
                  dark
                  large
                  color="orange"
                  class
                  block
                >
                  <v-icon left dark>mdi-login-variant</v-icon>Login to Book
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import formatters from "@/helpers/formatters";
import apiHelper from "@/helpers/apiHelper";
import validators from "@/helpers/validators";
import routerHelper from "@/helpers/routerHelper";

export default {
  name: "VisitBookingDetails",
  data: () => ({
    visitBooking: null,
  }),
  computed: {
    ...mapState(["visitBookingSearchResult", "settings"]),
  },
  methods: {
    ...mapMutations(["updatePreCasAuthState"]),
    loginAuth() {     
      routerHelper.verifyAuthRoute(this.$route.name);
    },
    customGoBack() {
      if (this.$route.query.reloaded) {
        //Prevent redirecting back to CAS login page after logging in
        this.goHome();
      } else {
        this.goBack();
      }
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatAvailability(availableVisitCapacity, visitCapacityOfTheTimeSlot) {
      return `${availableVisitCapacity}/${visitCapacityOfTheTimeSlot}`;
    },
    // formatAvailability(pax, availableVisitCapacity, visitCapacityOfTheTimeSlot) {
    //   return `${pax} (${availableVisitCapacity}/${visitCapacityOfTheTimeSlot})`;
    // },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    async book(visitBooking) {
      const response = await apiHelper.bookVisit(
        visitBooking.branchId,
        visitBooking.startTime,
        visitBooking.durationInMinutes,
        visitBooking.pax
      );

      const tabNo = validators.isToday(
        visitBooking.startTime,
        this.time.nowMoment
      )
        ? 0
        : 1;

      this.commonResponseHandler(
        response,
        window.$msg.bookSuccess,
        window.$msg.bookFail,
        null,
        () =>
          this.$router.push({ name: "MyBookings", params: { tabNo: tabNo } }),
        null
      );
    },
    setContentHeight() {
      if (this.$refs.bookingDetailsScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.bookingDetailsScrollable.style.height = contentHeight + "px";
      }
    },
  },
  activated() {
    this.visitBooking = this.visitBookingSearchResult.visitCapacity;

    this.$nextTick(() => this.setContentHeight());
  },
};
</script>

<style scoped>
.button-group .col {
  margin: 5px;
  padding: 0px;
}
</style>
